export const getXApiKeyHeader = () => process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? process.env.REACT_APP_API_GATEWAY_AK as string
  : process.env.REACT_APP_AK as string;
